// Automaticky nastaví stránce její title.
export default {
  created() {
    this.$utils.setPageTitle(this);
  },
};
